import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {RendererOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {
  PopoverCoordinator,
  PopoverTransferProps,
} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {StyledTabBaseElement} from './tabCommon';

/*
 * Props.
 */

export interface TabDropdownElementProps {
  label: ReactNode;
  renderDropdown: RendererOf<PopoverTransferProps>;
}

/*
 * Styles.
 */

const StyledIcon = styled(Icon)`
  margin-left: 4px;
`;

/*
 * Component.
 */

export const TabDropdownElement: FC<TabDropdownElementProps> = ({label, renderDropdown}) => {
  const renderButton = () => (
    <StyledTabBaseElement $hideBorders $noMarginRight>
      {label}
      <StyledIcon name="chevronDownSmall" />
    </StyledTabBaseElement>
  );

  return <PopoverCoordinator renderButton={renderButton} renderModal={renderDropdown} />;
};
